import renderTemplate from './render_template';
import htmlToElems from './html_to_elems';

export default function renderTemplateHTML(path, args = {}) {
  const html = renderTemplate(path, args);

  return htmlToElems(html);
}
